import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  ApiRef,
  BackstageIdentityApi,
  configApiRef,
  createApiRef,
  discoveryApiRef,
  OAuthApi,
  oauthRequestApiRef,
  ProfileInfoApi,
  SessionApi,
  gitlabAuthApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import {
  ApiBlueprint,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
  OverridableExtensionDefinition,
  storageApiRef,
} from '@backstage/frontend-plugin-api';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';
import { signalApiRef } from '@backstage/plugin-signals-react';

export namespace providersApiRefs {
  export const microsoftProviderAuthApiRef: ApiRef<
    OAuthApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
  > = createApiRef({
    id: 'microsoft-provider',
  });
}

export const apis: OverridableExtensionDefinition[] = [
  ApiBlueprint.make({
    name: 'scmIntegrationsApiRef',
    params: defineParams =>
      defineParams({
        api: scmIntegrationsApiRef,
        deps: { configApi: configApiRef },
        factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
      }),
  }),
  ApiBlueprint.make({
    name: 'scmAuthApiRef',
    params: defineParams =>
      defineParams({
        api: scmAuthApiRef,
        deps: {
          gitlabAuthApi: gitlabAuthApiRef,
        },
        factory: ({ gitlabAuthApi }) => ScmAuth.forGitlab(gitlabAuthApi),
      }),
  }),
  ApiBlueprint.make({
    name: 'microsoftProviderAuthApiRef',
    params: defineParams =>
      defineParams({
        api: providersApiRefs.microsoftProviderAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
          const authEnvironment =
            configApi.getOptionalString('auth.environment');
          const clientId = configApi.getString(
            `auth.providers.microsoft-provider.${authEnvironment}.clientId`,
          );

          return OAuth2.create({
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: providersApiRefs.microsoftProviderAuthApiRef.id,
              title: 'Microsoft',
              icon: () => null,
            },
            environment: authEnvironment,
            defaultScopes: [
              'openid',
              'profile',
              'email',
              `api://${clientId}/access_as_user`,
            ],
            configApi,
          });
        },
      }),
  }),

  ApiBlueprint.make({
    name: 'userSettingsStorageApiRef',
    params: defineParams =>
      defineParams({
        api: storageApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          errorApi: errorApiRef,
          fetchApi: fetchApiRef,
          identityApi: identityApiRef,
          signalApi: signalApiRef,
        },
        factory: deps => UserSettingsStorage.create(deps),
      }),
  }),
];
